import { render, staticRenderFns } from "./DatepickerDayViewOnly.vue?vue&type=template&id=95126700&"
import script from "./DatepickerDayViewOnly.vue?vue&type=script&lang=js&"
export * from "./DatepickerDayViewOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports